<p-toast></p-toast>

<div class="relative flex items-center justify-center min-h-screen w-full overflow-x-hidden">
  <div class="fixed inset-0 z-0 bg-cover bg-center bg-no-repeat"
    style="background-image: url('images/backgrounds/bg-1.png');"></div>

  <div class="z-10 bg-[#FBFBFB]/10 border-[0.8px] border-[#F9FAFB]/30 relative flex flex-col items-center justify-center
              transition-all duration-300 ease-in-out overflow-hidden
              shadow-[0_3.2px_3.2px_0_rgba(0,0,0,0.2)] rounded-[13.09px]
              w-[92%]
              md:w-[600px]
              2xl:w-[750px] 2xl:rounded-[20px]">

    <img src="images/assets/asset-1.png" alt="asset-1"
      class="absolute pointer-events-none z-0 h-auto transition-all duration-300
             w-[140px] right-[-12%] top-[40%]
             md:w-[223px] md:right-[-11%] md:top-[28%]
             2xl:w-[270px] 2xl:right-[-12%] 2xl:top-[26%]">

    <div class="z-10 w-full max-w-[450px] 2xl:max-w-[600px] flex flex-col items-center px-4 md:px-0 py-6">

      <div class="mb-4 mt-5 w-full flex justify-center">
        <img src="images/logos/logo-1.png" alt="Logo"
             class="object-contain w-[150px] md:w-[180px] 2xl:w-[290px] h-auto">
      </div>

      <div class="text-center w-full mb-5 mt-3">
        <typography tag="h3" variant="h3" weight="bold" color="text-black">Sign In</typography>
      </div>

      <form (ngSubmit)="onLogin()" #loginForm="ngForm" class="w-full flex flex-col gap-5 2xl:gap-8">

        <div class="flex flex-col gap-2 w-full">
          <typography tag="label" variant="body-1" class="2xl:text-[1.2rem]" weight="semibold" color="text-black">
            Email <span class="text-red-600">*</span>
          </typography>
          <input pInputText type="email" name="email" [(ngModel)]="email" placeholder="Email" autocomplete="email"
            class="w-full h-[52px] 2xl:h-[60px] 2xl:text-lg rounded-lg border border-gray-500 bg-white text-black px-4 outline-none focus:border-blue-500 transition-all !placeholder:text-[12px] 2xl:!placeholder:text-[18px]" />
        </div>

        <div class="flex flex-col gap-2 w-full">
          <typography tag="label" variant="body-1" class="2xl:text-[1.2rem]" weight="semibold" color="text-black">
            Password <span class="text-red-600">*</span>
          </typography>

          <p-password
            name="password"
            [(ngModel)]="password"
            [toggleMask]="true"
            [feedback]="false"
            placeholder="Password"
            autocomplete="current-password"
            styleClass="w-full custom-password relative"
            inputStyleClass="w-full h-[52px] 2xl:h-[60px] 2xl:text-lg rounded-lg border border-gray-500 bg-white text-black px-4 pr-12 outline-none focus:border-blue-500">
          </p-password>
        </div>

        <button type="submit" [disabled]="loading() || !email() || !password()"
          class="w-full bg-black text-white font-bold rounded-lg shadow-md mt-2 mb-5 2xl:mt-10 hover:bg-zinc-800 transition-all flex items-center justify-center h-[52px] 2xl:h-[55px] disabled:opacity-70 disabled:cursor-not-allowed">

          @if (loading()) {
            <i class="pi pi-spin pi-spinner text-[20px] 2xl:text-[24px]"></i>
          } @else {
            <typography weight="bold" variant="h6" class="2xl:text-xl" color="text-white">
              Sign In
            </typography>
          }
        </button>
      </form>
    </div>
  </div>
</div>
